<template lang="pug">
  div
    p.m-0.text-muted
      | Showing 
      span {{data.from}}
      |  to 
      span {{data.to}}
      |  of 
      span {{data.total}}
      |  entries
    ul.pagination.m-0.ml-auto
      li.page-item(:class="data.current_page-1 < 1 ? 'disabled': ''")
        a.page-link(href='#' tabindex='-1' @click.prevent="change_page(page-1)")
          | &lt; prev
      li.page-item(v-for="number in data.last_page" :class="number==data.current_page?'active':''")
        a.page-link(href='#' @click.prevent="change_page(number)" v-if="show_page(number)") {{number}}
        span.text-muted(v-else-if="show_elipse(number)") ...
      li.page-item(:class="data.current_page+1 > data.last_page ? 'disabled': ''")
        a.page-link(href='#' @click.prevent="change_page(page + 1)")
          | next &gt;
</template>

<script>
export default {
  props: ['data', 'page'],
  data(){
    return {
      display: 2,
    }
  },
  methods: {
    show_page(page){
      if(page==1 || page==this.data.last_page){
        return true;
      }
      if(Math.abs(this.page-page)>this.display){
        return false;
      }
      else{
        return true;
      }
    },
    show_elipse(page){
      if(page==2 || page==this.data.last_page-1){
        return true;
      }
      else{
        return false;
      }
    },
    change_page(page){
      this.$emit('change', page);
    }
  }
}
</script>